import { render, staticRenderFns } from "./ListQuotation.vue?vue&type=template&id=620b69b7&scoped=true&"
import script from "./ListQuotation.vue?vue&type=script&lang=ts&"
export * from "./ListQuotation.vue?vue&type=script&lang=ts&"
import style0 from "./ListQuotation.vue?vue&type=style&index=0&id=620b69b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b69b7",
  null
  
)

export default component.exports